export function Hospital({ ...rest }) {
  return (
    <svg {...rest} viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.66667 19.25V5.5H9.16667V2.75H12.8333V5.5H18.3333V19.25H3.66667ZM5.5 17.4167H7.33333V15.5833H5.5V17.4167ZM5.5 13.75H7.33333V11.9167H5.5V13.75ZM5.5 10.0833H7.33333V8.25H5.5V10.0833ZM9.16667 17.4167H12.8333V13.75H9.16667V17.4167ZM9.16667 11.9167H12.8333V10.0833H9.16667V11.9167ZM10.0833 8.25V6.41667H11.9167V8.25H10.0833ZM14.6667 17.4167H16.5V15.5833H14.6667V17.4167ZM14.6667 13.75H16.5V11.9167H14.6667V13.75ZM14.6667 10.0833H16.5V8.25H14.6667V10.0833Z"
        fill="#666666"
      />
    </svg>
  );
}
